export default {
    // 分页获取贷款列表
   getMortgageRollingList:"/mortgage/getMortgageRollingList", 
//    文件上传
getMortgageUpload:"/mortgage/uploadFile",
// 新增贷款合同
getMortgageAdd:"/mortgage/saveMortgageRolling",
};
